import { Component, Input, inject } from '@angular/core';
import { AssetService, ReactiveComponent, IconV2Module } from '@schenck/rotec-components';
import { AssetType } from 'src/types/asset-types';
import { TilePagesService } from '../tile-page/tile-pages.service';
import { AssetTypeService } from '../../services/asset-type-service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mc-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.less'],
  imports: [IconV2Module],
})
export class LegendComponent extends ReactiveComponent {
  public assetService = inject(AssetService);
  public tilePagesService = inject(TilePagesService);
  public assetTypeService = inject(AssetTypeService);

  /**
   * Name of the main asset.
   */
  @Input()
  asset!: string;
  /**
   * Name of the comparing asset.
   */
  @Input()
  compareAsset?: string;
  /**
   * Determines if colored circle should be shown.
   * Has to be set to false if it should not be shown
   */
  @Input()
  showCircle = true;
  /**
   * It changes the colors so that the items can be seen properly on a dark background.
   * Default false.
   */
  @Input()
  darkMode = false;

  /**
   * Name of rotor type for quality tab.
   */
  @Input()
  rotorType?: string;
  private _assetType: AssetType;
  public _referenceType: AssetType;

  constructor() {
    super();
    this.tilePagesService.state$.pipe(takeUntil(this.onDestroy$)).subscribe((state) => {
      this._assetType = this.assetTypeService.getAssetType(state.main?.selected);
      this._referenceType = this.assetTypeService.getAssetType(state.compare?.selected);
    });
  }

  public get assetType() {
    return this.getSvgIcon(this._assetType);
  }
  public get referenceType() {
    return this.getSvgIcon(this._referenceType);
  }

  private getSvgIcon(assetType: AssetType): string {
    return assetType === 'plant' ? 'plant' : assetType === 'group' ? 'folder' : 'machine';
  }
}
